import React from "react";

import * as styles from "../styles/ContentWrapper.module.css";

const ContentWrapper = ({
  top,
  children,
}: {
  top?: boolean;
  children?: React.ReactNode;
}) => {
  return (
    <div className={styles.container}>
      <div
        className={styles.inner}
        style={{ alignSelf: top ? "flex-start" : "center" }}
      >
        {children}
      </div>
    </div>
  );
};

export default ContentWrapper;
